import React from "react";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import PermissionGate from "~/components/PermissionGate";
import GeneralInformationForm from "../../../../components/lsp/generalinfo/GeneralInfoFrom";
import CustomeButton from "../../../../components/Button/index";
import Notification from "../../../../components/entities/notification/Notification";
import useLspUpdating from "../../actions/useLspUpdating";
import API_ROUTES from "../../../../api-routes";
import AuditSidebar from "../../../../components/audit-sidebar/AuditSidebar";
import LspLogo from "./LspLogo";

const LspGenInfo = () => {
  const { id } = useParams();
  const {
    genstate,
    handleEnableEdit,
    updateMsgState,
    handleUpdateLspGen,
    handleDiscardEdit,
    handleGenEditChange,
    setAuditSidebarVisible,
  } = useLspUpdating(id, false);

  const auditLabels = () => {
    return {
      create: "Local Team Created",
      update: "Information Updated",
      delete: "Information Deleted",
    };
  };

  return (
    <>
      {genstate.isAuditSidebarVisible && (
        <AuditSidebar
          heading="General Information"
          endpoint={API_ROUTES.FETCHLSP_AUDIT}
          id={id}
          labels={auditLabels}
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={genstate.isAuditSidebarVisible}
        />
      )}

      <Card className="card-onboard">
        <div className="formgrid grid flex justify-content-between mb-4">
          <p className="general-info">General Information</p>
          <PermissionGate resource="entity" action="modify" resourceId={id}>
            <div className="flex gap-1">
              {genstate.isEdit ? (
                <>
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="mr-2"
                    onClick={handleDiscardEdit}
                  />
                  <CustomeButton
                    label={!genstate?.isUpdating && "Save Changes"}
                    variant="contained"
                    onClick={handleUpdateLspGen}
                    loading={genstate?.isUpdating}
                    disabled={genstate?.isUpdating || genstate?.isSaveBtn}
                    className={`mr-2 access-btn  ${genstate?.isSaveBtn && "disable"}`}
                  />
                </>
              ) : (
                <>
                  <CustomeButton
                    label="View History"
                    variant="outlined"
                    className="mr-2"
                    icon="pi pi-history"
                    iconPos="right"
                    onClick={() => setAuditSidebarVisible(true)}
                  />

                  <CustomeButton
                    label="Edit"
                    variant="contained"
                    className="mr-2 access-btn"
                    onClick={handleEnableEdit}
                    icon="pi pi-pencil"
                    iconPos="right"
                  />
                </>
              )}
            </div>
          </PermissionGate>

          <Notification
            successMessage={genstate.updatesmsg}
            setSuccessMessage={updateMsgState}
          />
        </div>

        <div className="formgrid grid">
          <LspLogo name={genstate.geninfo?.trading_name} />
          <GeneralInformationForm
            generaldata={genstate.geninfo}
            isLoading={genstate.status === "getlsploading"}
            handleChange={handleGenEditChange}
            isEdit={genstate.isEdit}
          />
        </div>
      </Card>
    </>
  );
};

export default LspGenInfo;
